/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />
/// <reference path = "../../node_modules/@types/select2/index.d.ts" />

import listenForClick from "./clickHandler";

let select2Instances : any[] = [];

function getSiblings (elem : HTMLElement) {

	// Setup siblings array and get the first sibling
	let siblings = [] as HTMLElement[];
	let sibling = elem.parentNode.firstElementChild as HTMLElement;

	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextElementSibling as HTMLElement
	}

	return siblings;

};

function setSbilingsClass(elem : HTMLElement, className : string, isAdd : boolean){
	let siblings = getSiblings(elem);

	siblings.forEach(sibling => {
		if (isAdd)
			sibling.classList.add(className);
		else
			sibling.classList.remove(className);
	});
}

const closedClass = "mi-closed";

// Toggle the sibling.
export function handleToggleSibling(){
	let allToggleHeader = document.querySelectorAll(".mi-toggle-sibling");

	allToggleHeader.forEach(_header => {
		let header = _header as HTMLElement;
		if (header.classList.contains("mi-skip-toggle"))
			return;

		let updateSiblings = () => {
			setSbilingsClass(header, "mi-hidden", header.classList.contains(closedClass));
		}
		updateSiblings();

		listenForClick(header, () => {
			if (header.classList.contains(closedClass))
				header.classList.remove(closedClass);
			else
				header.classList.add(closedClass);

			updateSiblings();
		});

		let handleResize = () => {
			let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			if (screenWidth > 1024)
				setSbilingsClass(header, "mi-hidden", false);
			else
				updateSiblings();
		}

		handleResize();
		window.addEventListener("resize", handleResize);
	});
}

// If the section has no slide, then no drop shadow.
export function handleRelatedProducts(){
	if (!(window as any).mi_isSingleProductPage)
		return;

	let slides = document.querySelectorAll(".mi-single-product-slide");
	if (slides.length == 0)
		return;

	let relatedProductColumn = document.querySelector(".mi-related-products-column") as HTMLElement;
	if (relatedProductColumn)
		relatedProductColumn.classList.add("has-data"); // Then the section shows a drop shadow only if it has slides.
}

// move the tags div to buttom.
export function adjustPostTags(){
	let postGrids = document.querySelectorAll(".mi-posts");
	
	postGrids.forEach(_postGrid => {
		let postGrid = _postGrid as HTMLElement;

		let eachPosts = postGrid.querySelectorAll(".uael-post__content-wrap");

		eachPosts.forEach(_eachPost => {
			let eachPost = _eachPost as HTMLElement;

			let tagsWrapper = eachPost.querySelector(".uael-post__terms-meta-tag") as HTMLElement;

			if (tagsWrapper)
				eachPost.appendChild(tagsWrapper);
		});
	});
}

// Find the first form as anchor target of request button
// Assume the first form is the request quoation form.
// Find the anchor is better, as after submission, the anchor is still valid.
export function getFirstFormAnchorID(){
	let firstForm = document.querySelector(".gform_wrapper .gform_anchor") as HTMLElement;
	if (firstForm)
		return "#" + firstForm.id;
	else
		return null;
}

export function removeLastSlashFromBreadcrumb(){
	let allbreadcrumbs = document.querySelectorAll(".woocommerce-breadcrumb");
	allbreadcrumbs.forEach(_crumb => {
		let crumb = _crumb as HTMLElement;
		let lastChild = crumb.lastChild;
		let lastChildContent = (lastChild as any).data as string;
		//console.log(lastChildContent);
		if (lastChildContent && lastChildContent.trim() == "/"){
			lastChild.remove();
		}
	});
}

export function handleTopBigSearchAndSearchPopupButton(subClass : string){
	//console.log("handleTopBigSearchAndSearchPopupButton of: " + subClass);

	let bigSearchWrappers = document.querySelectorAll(".mi-search-big-wrapper." + subClass);
	bigSearchWrappers.forEach(_bigSearchWrapper => {
		let bigSearchWrapper = _bigSearchWrapper as HTMLElement;
		if (!bigSearchWrapper.dataset.miProcessed){
			bigSearchWrapper.dataset.miProcessed = "processed";

			{
				// use to update the form's action:
				let form = bigSearchWrapper.querySelector("form") as HTMLFormElement;
				if (!form)
					console.error("Missing form element");


				// Change to select2 drop down.
				let dropdowns = bigSearchWrapper.querySelectorAll(".mi-simple-dropdown");
				dropdowns.forEach(_dropdown => {
					let dropdown = _dropdown as HTMLSelectElement;

					let instance = jQuery(dropdown).select2({
						minimumResultsForSearch: -1,
						selectionCssClass: "mi-search-big-cat-dd",
						dropdownCssClass: "mi-simple-dropdown-content mi-upper",
						width: "145px"
					} as any) as any as JQuery<HTMLElement>;

					select2Instances.push(instance);

					let updateFormAction = (selectEle : HTMLSelectElement) => {
						let selectedValue = selectEle.options[selectEle.selectedIndex].value;
						//console.log(selectedValue);
						form.action = selectedValue;
					}
					updateFormAction(dropdown);
					
					instance.on("change.select2", (event : Event) => {
						updateFormAction(event.currentTarget as HTMLSelectElement);
					});
				});
			}

			{
				// when click on the frequent search words, update the input field.

				let input = bigSearchWrapper.querySelector("input") as HTMLInputElement;
				let searchButton = bigSearchWrapper.querySelector("button.elementor-search-form__submit") as HTMLButtonElement;

				let searchTermList = bigSearchWrapper.querySelector(".mi-top-search-list");
				searchTermList.childNodes.forEach(_searchTerm => {
					if (_searchTerm.nodeName == "DIV"){
						let searchTerm = _searchTerm as HTMLDivElement;
						if (!searchTerm.classList.contains("heading")){
							listenForClick(searchTerm, () => {
								input.value = searchTerm.textContent;
								searchButton.click();
							});
						}
					}
				});
			}

			{
				// Elementor cannot set the popup close by clicking on the overlay background.
				// So I add a div on top of the overlay area and mimic click on the original close button.
				let popup = document.querySelector(".mi-search-popup");

				if (popup){
					let emptyDiv = popup.querySelector(".mi-dialog-empty-space") as HTMLElement;
					if (!emptyDiv){
						let closeButton = popup.querySelector(".dialog-close-button") as HTMLElement;
						let message = popup.querySelector(".dialog-message") as HTMLElement;

						emptyDiv = document.createElement("div");
						emptyDiv.classList.add("mi-dialog-empty-space");
						listenForClick(emptyDiv, () => {
							closeButton.click();

							// When the dialog close, should close the select2's popup.
							select2Instances.forEach(instance => {
								instance.select2('close');
							});
						});

						message.appendChild(emptyDiv);
					}
				}
			}
		};
	});
}

export function delayShowMobileMagnifyGlass(){
	// don't know why, the magnify glass popup big when page load.
	// so add a delay to show it.
	let glasses = document.querySelectorAll(".mi-magnify-glass");
	glasses.forEach(_glass => {
		let glass = _glass as HTMLSelectElement;
		glass.classList.remove("mi-hidden");
	});
}

export function handleProductFilterDropdown(){
	let dropdowns = document.querySelectorAll(".mi-prod-cat-select");
	dropdowns.forEach(_dropdown => {
		let dropdown = _dropdown as HTMLSelectElement;

		let instance = jQuery(dropdown).select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: "mi-simple-dropdown-content",
			width: "50%"
		} as any) as any as JQuery<HTMLElement>;
		// container class added by this.
		(dropdown.nextElementSibling as HTMLElement).classList.add("mi-prod-cat-dd-wrapper");

		select2Instances.push(instance);

		let handleClick = (selectEle : HTMLSelectElement) => {
			let url = selectEle.options[selectEle.selectedIndex].value;
			window.location.href = url;
		}
		
		instance.on("change.select2", (event : Event) => {
			handleClick(event.currentTarget as HTMLSelectElement);
		});
	});	
}

export function handleWooCommSortByDropdown(){
	let dropdowns = document.querySelectorAll(".woocommerce-ordering select");
	dropdowns.forEach(_dropdown => {
		let dropdown = _dropdown as HTMLSelectElement;

		let instance = jQuery(dropdown).select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: "mi-simple-dropdown-content",
			width: "100%"
		} as any) as any as JQuery<HTMLElement>;
		// container class added by this.
		(dropdown.nextElementSibling as HTMLElement).classList.add("mi-woo-ordering-dd-wrapper");

		select2Instances.push(instance);
	});	
}

export function handleSimpleToggle(){
	let marketValues : string[];
	{
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const marketValue = urlParams.get("market") ?? '';
		marketValues = marketValue.split("~");
	}

	let target = ".mi-checkbox-wrapper .container";
	let checkboxes = document.querySelectorAll(target);
	checkboxes.forEach(_checkbox => {
		let checkbox = _checkbox as HTMLSelectElement;

		if (marketValues.indexOf(checkbox.dataset.value) != -1)
			checkbox.classList.add("mi-selected");

		listenForClick(checkbox, () => {
			checkbox.classList.toggle("mi-selected");

			// grab the selected market checkbox, combine to new query and pass query to server.
			let selectedCheckboxes = document.querySelectorAll(target + ".mi-selected");
			let selectedValues: string[] = [];
			selectedCheckboxes.forEach(_innerCheckbox => {
				let innerCheckbox = _innerCheckbox as HTMLElement;
				selectedValues.push(innerCheckbox.dataset.value);
			})

			const queryString = window.location.search;
			//console.log(queryString);
			const urlParams = new URLSearchParams(queryString);
			const marketValue = selectedValues.join("~");
			urlParams.delete("paged"); // Better remove page param.
			urlParams.set("market", marketValue);
			//console.log(urlParams.toString());
			let oldUrlNoQueryString = window.location.href.split("?")[0];
			let oldUrlSplitted = oldUrlNoQueryString.split("/");
			//console.log(oldUrlSplitted);
			
			let checkPos = 2;
			if (oldUrlSplitted.length > 1 && oldUrlSplitted[oldUrlSplitted.length - 1] == ""){
				checkPos++;
			}
			if (oldUrlSplitted.length > checkPos){
				if (oldUrlSplitted[oldUrlSplitted.length - checkPos] == "page"){
					while(checkPos > 0){
						oldUrlSplitted.pop()
						checkPos--;
					}

					oldUrlNoQueryString = oldUrlSplitted.join("/") + "/";
				}
			}

			let newUrl = oldUrlNoQueryString + "?" + urlParams.toString();
			//console.log(newUrl);
			window.location.href = newUrl;
		});
	});
}

export function moveAboutUsServiceCategories(){
	//console.log("moveAboutUsServiceCategories");

	const attribute = "data-mi-move-these-wrapper";

	let moveHeres = document.querySelectorAll(".mi-move-here");
	moveHeres.forEach(_moveHere => {
		let moveHere = _moveHere as HTMLElement;
		let slideWrapperItem = moveHere.attributes.getNamedItem(attribute);

		if (!slideWrapperItem){
			console.log("Cannot find the attribute: " + attribute);
			return;
		}

		let slideWrapperId = slideWrapperItem.value;
		let slideWrapper = document.querySelector("#" + slideWrapperId);
		if (!slideWrapper){
			console.log("Cannot find the id: " + slideWrapperId);
			return;
		}

		let slides = slideWrapper.querySelectorAll(".mi-move-these");
		if (slides.length == 0){
			console.log("No slide to move, error?");
			return;
		}

		let parent = moveHere.parentElement as HTMLElement;
		moveHere.remove();
	
		slides.forEach(_slide => {
			let slide = _slide as HTMLElement;
			parent.appendChild(slide);
		})
	
	})
}

export function disableMiniCartOnMobile(){
	let woo_cart = document.querySelector('.ast-mobile-header-wrap .ast-header-woo-cart');
	if (!woo_cart)
		return;

	woo_cart.addEventListener('click', (event) => {
		//event.preventDefault(); // let it open the link.
		event.stopImmediatePropagation(); // prevent theme's action.
	});
}


export function handleMobileMenuItemClick() {
	let popup = document.querySelector("#ast-mobile-popup");

	let allLink = popup.querySelectorAll("a.menu-link");
	allLink.forEach(_link => {
		let link = _link as HTMLAnchorElement;

		link.addEventListener('click', () => {
			window.location.href = link.href;
		});
	});
}

export function hideAllTheseDivs(elements : NodeListOf<Element>){
	elements.forEach(element => {
		(element as HTMLElement).classList.add("mi-hidden");
	});
}

export function setGoogleTag(){

	// My product slides.
	{
		let allSingleProduct = document.querySelectorAll(".mi-single-product-slide");
		allSingleProduct.forEach(_singleProduct => {
			let singleProduct = _singleProduct as HTMLElement;
			let slug = singleProduct.dataset.slug;

			let image = singleProduct.querySelector(".mi-image");
			if (image){
				(image as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productImageClick",
						slug: slug
					});
				});
			}

			let name = singleProduct.querySelector(".mi-name");
			if (name){
				(name as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productNameClick",
						slug: slug
					});
				});
			}

			let price = singleProduct.querySelector(".mi-price");
			if (price){
				(price as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productPriceClick",
						slug: slug
					});
				});
			}

			let reqQuote = singleProduct.querySelector(".mi-request-quote");
			if (reqQuote){
				(reqQuote as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productReqQuoteClick",
						slug: slug
					});
				});
			}
		});
	}

	// alternative product lists:
	{
		let allSingleProduct = document.querySelectorAll(".elementor-portfolio-item.product");
		allSingleProduct.forEach(_singleProduct => {
			let singleProduct = _singleProduct as HTMLElement;
			let a = singleProduct.querySelector("a") as HTMLAnchorElement;
			let slug = getSlug(a.href);

			let image = singleProduct.querySelector(".elementor-portfolio-item__overlay"); // the overlay cover the whole image, so use this instead of img.
			if (image){
				(image as HTMLElement).addEventListener('click', (e) => {
					console.log("click on overlay: " + (e.target as HTMLElement).nodeName);
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: (e.target as HTMLElement).nodeName == "DIV" ? "productImageClick" : "productNameClick",
						slug: slug
					});
				}, false);
			}

			// let name = singleProduct.querySelector(".elementor-portfolio-item__title");
			// if (name){
			// 	(name as HTMLElement).addEventListener('click', () => {
			// 		(window as any).dataLayer = (window as any).dataLayer || [];
			// 		(window as any).dataLayer.push({
			// 			event: "productNameClick",
			// 			slug: slug
			// 		});
			// 	});
			// }
		});
	}

	// Post lists
	{
		let allPost = document.querySelectorAll(".uael-post-wrapper");
		allPost.forEach(_post => {
			let post = _post as HTMLElement;
			let a = post.querySelector("a") as HTMLAnchorElement;
			let slug = getSlug(a.href);

			let image = post.querySelector(".uael-post__thumbnail");
			if (image){
				(image as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "blogImageClick",
						slug: slug
					});
				});
			}

			let title = post.querySelector(".uael-post__title");
			if (title){
				(title as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "blogTitleClick",
						slug: slug
					});
				});
			}
	
		});
	}
}

function getSlug(url:string){
	let parts = url.split('/');
	let slug = parts.pop() || parts.pop();  // handle potential trailing slash

	return slug;
}

export function showProductList() {
	let allProductSlide = document.querySelectorAll(".mi-single-product-slide");
	allProductSlide.forEach(_productSlide => {
		let productSlide = _productSlide as HTMLElement;
		productSlide.classList.remove("mi-invis");
	});	
}

export function handleHomeGallery(){
	{
		let galleryWrappers = document.querySelectorAll(".mi-home-galleries-column .mi-home-gallery");
		let linkWrappers = document.querySelectorAll(".mi-home-galleries-column .mi-home-gallery-link");

		let count = 0;
		galleryWrappers.forEach((_gallery) => {
			let galleryWrapper = _gallery as HTMLDivElement;
			let linkWrapper = linkWrappers[count++] as HTMLDivElement;

			let gallerys = galleryWrapper.querySelectorAll(".e-gallery-item");
			let links = linkWrapper.querySelectorAll(".elementor-icon-list-item a");

			for(let j = 0; j < 5; j++){
				gallerys[j].addEventListener('click', () => {
					let link = links[j] as HTMLAnchorElement;
					link.click();
				});
			}
		});
	}

	{
		let gallerys = document.querySelectorAll(".mi-home-gallery");

		let handler = () => {		
			gallerys.forEach((_gallery) => {
				let gallery = _gallery as HTMLDivElement;
		
				let allChildren = gallery.querySelectorAll(".e-gallery-item");
		
				let target = allChildren[0] as HTMLDivElement;
				let targetChild = target.querySelector("div") as HTMLDivElement;
				let reference = allChildren[1] as HTMLDivElement;
		
				let width = reference.clientWidth;
				if (width > 0){
					//console.log(width);
					//console.log(target);
					if (window.innerWidth > 768){
						target.style.height = width + "px";
						targetChild.style.marginTop = "-" + width / 2 + "px";
					}
					else{
						target.style.height = "unset";
						targetChild.style.marginTop = "unset";
					}
				}
			});
		}

		window.addEventListener("resize", handler);
		document.body.addEventListener("toogle-shown", handler);
		setInterval(handler, 200);
	}
}

export function handleCaseStudyHeight(){
	let caseStudyAdvance = document.querySelector(".mi-case-study-advance") as HTMLElement;
	if (!caseStudyAdvance)
		return;

	let slides = caseStudyAdvance.querySelectorAll(".mi-single-case-slide .mi-image-wrapper");

	let resize = () => {
		slides.forEach(_slide => {
			let slide = _slide as HTMLElement;
			let width = slide.clientWidth;
			slide.style.height = width + "px";
		})
	}

	window.addEventListener("resize", resize);
	resize();
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Functions for OBOR registration form, only show input field when a check-box or radio-box is checked and make it required.
// toggleInput, toggleRadioInput, setUpMemberForm
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function toggleInput(checkTarget: HTMLInputElement, inputTarget: HTMLInputElement) {
	if (!checkTarget.checked) {
		inputTarget.classList.add('removeInput');
		inputTarget.removeAttribute("required");
	} else {
		inputTarget.classList.remove('removeInput');
		inputTarget.setAttribute("required", "required");
	} 
}

function toggleRadioInput(radioTarget: NodeList, inputTarget: HTMLInputElement) {
	for (let i = 0; i < radioTarget.length; i++) {
		let radioEle = radioTarget[i] as HTMLInputElement;
		if (radioEle.checked && radioEle.value === "Other") {
			inputTarget.classList.remove('removeInput');
			inputTarget.setAttribute("required", "required");
		} else {
			inputTarget.classList.add('removeInput');
			inputTarget.removeAttribute("required");
		} 
	}
}

export function setUpMemberForm () {
	/* For ::Membership Form - Individual:: */
	// Select Social Networking checkbox
	let socialOtherCheck = document.querySelector("#social_networking_channel_Other") as HTMLInputElement;	
	// Select Social Networking input field
	let socialOtherInput = document.querySelector("#social_networking_channel_other") as HTMLInputElement;
	// Add event listener on checkbox and init the function
	if (socialOtherCheck) {
		socialOtherCheck.addEventListener("change", () => toggleInput(socialOtherCheck, socialOtherInput));
	}
	if (socialOtherCheck && socialOtherInput) {
		toggleInput(socialOtherCheck, socialOtherInput); // Run once so the input field is hided
	}
	

	// Select All Business Nature Radio-box
	let businessOtherRadio = document.querySelectorAll('.obor-member-individual form input[name="business_nature"]') as NodeList;
	// Select Business Nature input field
	let businessOtherInput = document.querySelector(".obor-member-individual #business_nature_other") as HTMLInputElement;
	// Add event listener on All radio-box and init the function
	for (let i = 0; i < businessOtherRadio.length; i++) {
		if (businessOtherRadio[i]) {
			businessOtherRadio[i].addEventListener("change", () => toggleRadioInput(businessOtherRadio, businessOtherInput));
		}
	}
	if (businessOtherRadio && businessOtherInput) {
		toggleRadioInput(businessOtherRadio, businessOtherInput); // Run once so the input field is hided
	}
	

	/* For ::Membership Form - Corporate:: */
	// Select All Business Nature Radio-box
	let corBusinessOtherRadio = document.querySelectorAll('.obor-member-corporate form input[name="business_nature"]') as NodeList;
	// Select Business Nature input field
	let CorBusinessOtherInput = document.querySelector(".obor-member-corporate #business_nature_other") as HTMLInputElement;
	for (let i = 0; i < corBusinessOtherRadio.length; i++) {
		if (corBusinessOtherRadio[i]) {
			corBusinessOtherRadio[i].addEventListener("change", () => toggleRadioInput(corBusinessOtherRadio, CorBusinessOtherInput));
		}
	}
	if (corBusinessOtherRadio && CorBusinessOtherInput) {
		toggleRadioInput(corBusinessOtherRadio, CorBusinessOtherInput); // Run once so the input field is hided
	}
}